// extracted by mini-css-extract-plugin
export default {"alert":"src-components-Antd-Alert-css-module__alert--HWopQ","message":"src-components-Antd-Alert-css-module__message--LcC0D"};